//REACT-JS
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//EXPORT
import TableToExcel from 'react-html-table-to-excel';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class Table extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    componentDidMount() {
        
    }

    statusEnvio(tipo){
        if(tipo == "Enviado"){
            return(<td style={{color:"#009966"}}>Enviado</td>)
        }
        else if (tipo == "Entregue"){
            return(<td style={{color:"#EF7800"}}>Entregue</td>)
        }
        else if (tipo == "Aberto"){
            return(<td style={{color:"#0099FF"}}>Aberto</td>)
        }
        else if (tipo == "Rejeitado"){
            return(<td style={{color:"#C34E4E"}}>Rejeitado</td>)
        }
        else if (tipo == "Nao Enviado"){
            return(<td style={{color:"#C34E4E"}}>Não Enviado</td>)
        }
    }

    render() {

        const data = this.props.data; let html = "";

        if (data.results === undefined) {
            html = (<tr><td colSpan="4" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0) {
            html = (<tr><td colSpan="4" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.identificador}>
                    <td>{row.nomeContato}</td>
                    <td>{row.email}</td>
                    {this.statusEnvio(row.status)}
                    <td>{row.dataHoraEnvio}</td>
                    <td style={{display: "none"}}>{row.cpf}</td>
                    <td style={{display: "none"}}>{row.codigo} </td>
                    <td style={{display: "none"}}>{row.endereco}</td>
                    <td style={{display: "none"}}>{row.data1}</td>
                    <td style={{display: "none"}}>{row.data2}</td>
                    <td style={{display: "none"}}>{row.valor}</td>
                    <td style={{display: "none"}}>{row.telefone}</td>
                    <td style={{display: "none"}}>{row.cidade}</td>
                    <td style={{display: "none"}}>{row.remetenteEmail}</td>
                    <td style={{display: "none"}}>{row.assunto}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <div className="box-export ml-auto">Exportar dados como:
                        {this.export('excel')}
                </div>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="tb-table-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Nome do contato</th>
                            <th>E-mail</th>
                            <th>Status</th>
                            <th>Data/Hora do envio</th> 
                            <th style={{display: "none"}}>CPF</th> 
                            <th style={{display: "none"}}>Código </th> 
                            <th style={{display: "none"}}>Endereço</th> 
                            <th style={{display: "none"}}>Data 1</th> 
                            <th style={{display: "none"}}>Data 2</th> 
                            <th style={{display: "none"}}>Valor</th> 
                            <th style={{display: "none"}}>telefone</th> 
                            <th style={{display: "none"}}>Cidade</th>
                            <th style={{display: "none"}}>remetenteEmail</th>
                            <th style={{display: "none"}}>assunto</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>
            </div>
        )
    }

    export(tipo){
        if(tipo == "excel"){
            return(<TableToExcel id="test-table-xls-button" className="btn-export" table="tb-table-export" filename="relatorio_envio_simples" buttonText="Excel"/>)
        }        
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Table));